export default "__VITE_ASSET__CSEdeBuV__"